import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  Button,
  Box,
  Card,
  CardContent,
  CardActions,
  CardActionArea,
  CardMedia,
  Container,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography
} from '@material-ui/core';
import Client from '../../domain/models/client';

const CardContainer = styled.div`
  display: flex;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%),
    0px 1px 3px 0px rgb(0 0 0 / 12%);
  width: 100%;
  height: 200px;
`;
const Half = styled.div`
  width: 100%;
  img {
    max-height: 100%;
    max-width: 100%;
  }
`;

type PropsType = {
  client: Client;
};

function ClientCard(props: PropsType) {
  const { client } = props;
  const [imageUrl, setImageUrl] = useState(null);
  const query =
    window && window.location && window.location.search && window.location.search.length > 0
      ? window.location.search
      : '';

  useEffect(() => {
    if (client?.media_profile) {
      setImageUrl(client.media_profile.thumbnailLargeUrl);
    } else {
      const rndInt = Math.floor(Math.random() * 9) + 1;
      setImageUrl(`/images/mic-0${rndInt}.jpg`);
    }
  }, [client]);

  // const renderProperties = () => {
  //   return client.properties
  //     .filter(p => p.title.toLowerCase().indexOf('union') == -1)
  //     .map((p) => (
  //       <span key={p.id}><Property>{p.title}</Property> </span>
  //     ))
  // }

  const clientUrl = () => {
    if (client) {
      return `/clients/${client.slug}${query}`;
    }
    return `/demos`;
  };

  return (
    <Grid item xs={12} sm={6} md={4}>
      <CardContainer>
        <Half>
          <img src={imageUrl} />
        </Half>
        <Half>
          <Container style={{ padding: '.5rem 1rem' }}>
            <Typography gutterBottom variant="h5" component="h2">
              {client.name}
            </Typography>
            <div>
              <a href={clientUrl()} style={{ color: '#f9671e' }}>
                DETAILS
              </a>
            </div>
            {client.media_demo && client.media_demo.length > 0 && (
              <div>
                <a href={clientUrl()} style={{ color: '#f9671e' }}>
                  LISTEN
                </a>
              </div>
            )}
          </Container>
        </Half>
      </CardContainer>
    </Grid>
  );
}

export default ClientCard;
